export const RevisionDisplayMode = Object.freeze({
	activity: 'activity',
	edit: 'edit',
	embedded: 'embedded',
	presenter: 'presenter-mode',
	preview: 'preview',
	review: 'review',
	screenshot: 'screenshot',
	view: 'view'
});